import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimeRangeComponent } from './time-range.component';
import { MeasuresDatePickersModule } from '../measures-date-pickers/measures-date-pickers.module';
import { AtomsModule } from '@library/ui/atoms/atoms.module'
@NgModule({
    declarations: [
        TimeRangeComponent,
    ],
    exports: [
        TimeRangeComponent,
    ],
    imports: [
        CommonModule,
        MeasuresDatePickersModule,
        AtomsModule
    ]
})
export class TimeRangeModule { }
